import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41479278"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "view",
  "data-view": ""
}
const _hoisted_2 = { class: "header__content" }
const _hoisted_3 = { class: "header__container" }
const _hoisted_4 = { class: "header__title" }
const _hoisted_5 = { class: "header__new-flag" }
const _hoisted_6 = {
  key: 0,
  class: "header__favorite-flag inline"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Favorito ")
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "information" }
const _hoisted_10 = { class: "information__duration" }
const _hoisted_11 = { class: "information__rate" }
const _hoisted_12 = { class: "header__actions" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 0,
  class: "line-decoins"
}
const _hoisted_17 = { class: "box" }
const _hoisted_18 = { class: "course__about" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Sobre o treinamento:", -1))
const _hoisted_20 = { class: "course-description" }
const _hoisted_21 = { class: "instructors-previous-list" }
const _hoisted_22 = ["onClick", "title"]
const _hoisted_23 = { class: "course__learning" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "O que você vai aprender?", -1))
const _hoisted_25 = {
  key: 0,
  class: "course__instructors",
  "data-instructors": ""
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Instrutores:", -1))
const _hoisted_27 = ["data-instructor-index"]
const _hoisted_28 = { class: "instructor__information" }
const _hoisted_29 = { class: "instructor__name" }
const _hoisted_30 = ["data-biography"]
const _hoisted_31 = { class: "instructor__button-see" }
const _hoisted_32 = ["data-see-more", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_RecommendCourse = _resolveComponent("RecommendCourse")!
  const _component_TUIViewer = _resolveComponent("TUIViewer")!
  const _component_FakeIframe = _resolveComponent("FakeIframe")!
  const _component_AccordionItem = _resolveComponent("AccordionItem")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", {
      class: "header",
      style: _normalizeStyle({ backgroundImage: `url(${_ctx.course.bannerURL})` })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.course.title) + " ", 1),
            _withDirectives(_createElementVNode("span", _hoisted_5, " Novos conteúdos! ", 512), [
              [_vShow, _ctx.course.hasNewContent]
            ]),
            (_ctx.course.isFavorite)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("img", {
                    src: require(`../../assets/static/icons/heart-filled.svg`),
                    alt: "Favorito",
                    class: "favorite-icon"
                  }, null, 8, _hoisted_8)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, " Duração: " + _toDisplayString(_ctx.course.duration), 1),
          _createElementVNode("span", _hoisted_11, "Média geral: " + _toDisplayString(_ctx.course.rating ?? 0), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.onClick(_ctx.course)), ["prevent"])),
            class: "header__button"
          }, [
            (_ctx.userCourse.finished)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Assistir novamente"))
              : (_ctx.userCourse.enrolled)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Continuar"))
                : (_openBlock(), _createElementBlock("span", _hoisted_15, "Iniciar"))
          ]),
          (_ctx.course.haveCertification && _ctx.userCourse.finished)
            ? (_openBlock(), _createBlock(_component_CustomDropdown, {
                key: 0,
                items: _ctx.dropdownCertificateItems,
                title: "Certificação"
              }, null, 8, ["items"]))
            : _createCommentVNode("", true),
          _createVNode(_component_CustomDropdown, {
            items: _ctx.dropdownItems,
            title: "Outras opções"
          }, null, 8, ["items"]),
          _createVNode(_component_RecommendCourse, {
            "is-open": _ctx.isRecommendOpened,
            onToggle: _ctx.closeRecommendModal,
            title: `Recomendar: ${_ctx.course.title}`
          }, null, 8, ["is-open", "onToggle", "title"])
        ])
      ])
    ], 4),
    (_ctx.course.haveDecoins && _ctx.isDecolaTemplate())
      ? (_openBlock(), _createElementBlock("div", _hoisted_16))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("section", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_TUIViewer, {
            "model-value": _ctx.course.description
          }, null, 8, ["model-value"])
        ]),
        _createVNode(_component_FakeIframe, {
          introductoryContent: _ctx.course.introductoryContent
        }, null, 8, ["introductoryContent"]),
        _createElementVNode("ul", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instructors, (instructor, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "instructors-preview-item",
              onClick: _withModifiers(($event: any) => (_ctx.goToInstructor(index)), ["prevent"]),
              style: _normalizeStyle(
              `left: ${index * +2}rem; background-image: url(${
                instructor.image
              })`
            ),
              title: instructor.name
            }, [
              _createElementVNode("div", {
                class: "instructors-preview-item__fade",
                style: _normalizeStyle(`background-image: url(${instructor.image})`)
              }, null, 4)
            ], 12, _hoisted_22))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_23, [
        _hoisted_24,
        _createVNode(_component_Accordion, null, {
          default: _withCtx(() => [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (content, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createVNode(_component_AccordionItem, {
                    content: content,
                    onClickContent: ($event: any) => (_ctx.onClickContent(content))
                  }, null, 8, ["content", "onClickContent"])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      (_ctx.instructors)
        ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instructors, (instructor, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  "data-instructor-index": index,
                  class: _normalizeClass([
              'instructor',
              { selected: _ctx.selectedInstructorIndex === index }
            ])
                }, [
                  _createElementVNode("div", {
                    class: "instructor__image",
                    style: _normalizeStyle({ backgroundImage: `url(${instructor.image})` })
                  }, null, 4),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("span", _hoisted_29, _toDisplayString(instructor.name), 1),
                    _createElementVNode("p", {
                      "data-biography": index,
                      class: "instructor__biography"
                    }, _toDisplayString(instructor.biography), 9, _hoisted_30),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("button", {
                        "data-see-more": index,
                        class: "instructor__see-more",
                        onClick: ($event: any) => (_ctx.seeMoreDescription(index))
                      }, " ver mais ", 8, _hoisted_32)
                    ])
                  ])
                ], 10, _hoisted_27))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}